var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLargerNominalWidth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .e, .f {\r\n        fill: none;\r\n      }\r\n\r\n      .f {\r\n        stroke: #45484a;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 28,
    height: 28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 9.66,
    cy: 14.05,
    rx: 4.25,
    ry: 5.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 4.13,
    y1: 19.57,
    x2: 15.19,
    y2: 8.52
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "21.69 21.43 21.69 6.57 19.29 8.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 21.69,
    y1: 6.57,
    x2: 24.07,
    y2: 9.05
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargerNominalWidth);
export default __webpack_public_path__ + "static/media/larger-nominal-width.a1cc8e0c2ed0c2038eb4a471f1c7cfe2.svg";
export { ForwardRef as ReactComponent };